/*
  Landing-page attribution for the subscription-first product form.
  Loaded only by sections/product.liquid when purchase_layout is subscription_first; wraps that
  form's productForm() data before Alpine makes it reactive (no global fetch patching).
  ?nm_origin=main|hrt|glp1 on the product URL is the only source. A subscription add carries it as the
  private line property _nm_origin and the private cart attribute __nm_origin; any other add clears the
  attribute first. If that write fails nothing is added. After the add, the cart attribute is re-derived
  from the cart lines (cart-drawer-upgrade.js), which also does this before native checkout.
*/
(function (root) {
  var KEY = '__nm_origin';
  var ORIGINS = ['main', 'hrt', 'glp1'];

  function originFrom(search) {
    var value = new URLSearchParams(search || '').get('nm_origin');
    return ORIGINS.indexOf(value) === -1 ? '' : value;
  }

  function isSubscription(payload) {
    var item = payload && payload.items && payload.items[0];
    return Boolean(item && item.selling_plan);
  }

  function setOrigin(form, value) {
    var url = form.cartUpdateUrl || '/cart/update';
    var attributes = {};
    attributes[KEY] = value;
    return fetch(/\.js$/.test(url) ? url : url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (res) { return res.ok; }, function () { return false; });
  }

  function form(data, search) {
    var origin = originFrom(search === undefined ? root.location.search : search);
    var add = data.addToCart;
    var payload = Object.getOwnPropertyDescriptor(data, 'cartPayload');
    if (payload && payload.get) {
      Object.defineProperty(data, 'cartPayload', {
        configurable: true,
        enumerable: true,
        get: function () {
          var result = payload.get.call(this);
          var item = result.items[0];
          if (origin && item.selling_plan) item.properties = Object.assign({}, item.properties, { _nm_origin: origin });
          return result;
        }
      });
    }
    data.nmwBusy = false;
    data.addToCart = async function () {
      if (this.nmwBusy || this.isAdding) return;
      this.nmwBusy = true;
      try {
        var value = isSubscription(this.cartPayload) ? origin : '';
        if (!(await setOrigin(this, value))) {
          alert(this.addToCartError || 'Something went wrong. Please try again.');
          return;
        }
        await add.call(this);
        // theme.js addToCart: success leaves isAdded (drawer) or isAdding (checkout redirect) true; failure resets both.
        if (!this.isAdded && !this.isAdding) {
          if (value) await setOrigin(this, '');
        } else if (root.nmwCartOrigin) {
          await root.nmwCartOrigin.reconcile().catch(function () {});
        }
      } finally {
        this.nmwBusy = false;
      }
    };
    data.buyOneTime = function () {
      if (this.nmwBusy || this.isAdding) return;
      this.selectedOption = 'one-time';
      return this.addToCart();
    };
    return data;
  }

  var api = { KEY: KEY, originFrom: originFrom, isSubscription: isSubscription, form: form };
  root.nmwOrigin = api;
  if (typeof module === 'object' && module.exports) module.exports = api;
})(typeof window === 'undefined' ? globalThis : window);
